import TableAHSF from "../../../../Components/TableAHSF";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import VoluntaryCommunityWorkForm from "./VoluntaryCommunityWorkForm";
import { DeleteVolunteerCommunityWork } from "../../../../Redux/Reducers/Submitter/VolunteerCommunityWork";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import PopupAHSF from "../../../../Components/PopupAHSF";
const VoluntaryCommunityWork = (props) => {
  const lang = useSelector((state) => state.languageReducer.Language);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
 const {ApplicationInformationId} = useParams();
  const [PopupComponentStatus, SetPopupComponentStatus] = useState(false);
  const [volunteerCommunityWorkId, setvolunteerCommunityWorkId] =
    useState(false);
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "volunteerRole",
      ShowStatus: true,
      NmaeColumn: "المهمة التطوعية",
      NmaeColumnEN: "Volunteer Work",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "organization",
      ShowStatus: true,
      NmaeColumn: "الجهة (المؤسسة/الجامعة)",
      NmaeColumnEN: "Organization (Institution/University)",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "timePeriodFromNumber",
      ShowStatus: true,
      NmaeColumn: " الفترة من سنة",
      NmaeColumnEN: "Period of one year",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "timePeriodToNumber",
      ShowStatus: true,
      NmaeColumn: " الفترة الى سنة",
      NmaeColumnEN: "Period to one year",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },

    {
      KeyName: "natureOfWork",
      ShowStatus: true,
      NmaeColumn: " طبيعة العمل",
      NmaeColumnEN: "Nature of Work",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "attachedVolunteerCertificate",
      ShowStatus: true,
      NmaeColumn: "مرفق شهادة التطوع",
      NmaeColumnEN: "Attached Volunteer Certificate",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      typeColumn: "file",
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        let data = JSON.parse(e.target.value);

        setvolunteerCommunityWorkId(data.volunteerCommunityWorkId);
        setPopUpBodyStatus(true);
      },

      content: "",
      className: props.disabled ? "bi bi-eye-fill" : "bi bi-pencil-fill",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
      ShowHideBtn: [],
    },
    {
      Click: async (e) => {
        let data = JSON.parse(e.target.value);
        Swal.fire({
          title:
            lang == "ar"
              ? "  هل انت متأكد من الحذف ؟"
              : "Are you sure you want to delete?",
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: lang == "ar" ? "تأكيد" : "Confirmed",
          cancelButtonText: lang == "ar" ? "إلغاء" : "Cancel",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            var result = await dispatch(
              DeleteVolunteerCommunityWork({
                volunteerCommunityWorkId: data.volunteerCommunityWorkId,
              })
            );
            if (result.payload.code == 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title:
                  lang == "ar"
                    ? "تم حفظ المعلومات بنجاح"
                    : "Saved Successfully",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              dispatch(setRefreshTable({ tableId: "VoluntaryCommunityWork" }));
            }
          }
        });
      },

      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "",
      ShowStatus: !props.disabled,
      ShowHideBtn: [
        // {
        //   KeyName: "applicationStatusId",
        //   Value: "f4c6c3e1-c49e-4361-8c86-c3015da12750",
        //   statusToWork: true,
        // },
      ],
    },
  ];
  const RequestsColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <VoluntaryCommunityWorkForm
        FormStatus={"Add"}
        setRefreshDataFromClosePageVoluntaryCommunityWork={
          props.setRefreshDataFromClosePageVoluntaryCommunityWork
        }
        refreshDataFromClosePageVoluntaryCommunityWork={
          props.refreshDataFromClosePageVoluntaryCommunityWork
        }
      />
    ),
    maxWidth: "600px",
    maxHeight: "600px",
    idssss: "SecondarySectors",
    titleEN: "Volunteer and community work",
    title:
      lang == "ar"
        ? "الأعمال التطوعية والمجتمعية إن وجد"
        : "Volunteer and community work",
  };

  const closePopupComponent = () => {
    SetPopupComponentStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: (
      <VoluntaryCommunityWorkForm
        volunteerCommunityWorkId={volunteerCommunityWorkId}
        FormStatus={"Edit"}
        disabled={props.disabled}
        setRefreshDataFromClosePageVoluntaryCommunityWork={
          props.setRefreshDataFromClosePageVoluntaryCommunityWork
        }
        refreshDataFromClosePageVoluntaryCommunityWork={
          props.refreshDataFromClosePageVoluntaryCommunityWork
        }
      />
    ),

    title: "",
    maxWidth: "600px",
    maxHeight: "600px",
    idssss: "SecondarySectors",
    titleEN: "Practical Experiences",
    title:
      lang == "ar"
        ? "الأعمال التطوعية والمجتمعية إن وجد"
        : "Volunteer and community work",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        lang={localStorage.getItem("lang")}
        setRefreshDataFromClosePageVoluntaryCommunityWork={
          props.setRefreshDataFromClosePageVoluntaryCommunityWork
        }
        refreshDataFromClosePageVoluntaryCommunityWork={
          props.refreshDataFromClosePageVoluntaryCommunityWork
        }
        tableId="VoluntaryCommunityWork"
        uniqueValue={""}
        valueButtonAction={""}
        URL={`api/WQ_NT_VC_VolunteerCommunityWork/GetWQ_NT_VC_VolunteerCommunityWorkList`}
        UrlBody={{
          applicationInformationId: localStorage.getItem(
            "ApplicationInformationId"
          )||
          ApplicationInformationId,
        }}
        fileStoreName="VolunteerCommunityWork"
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الأعمال التطوعية والمجتمعية إن وجد"}
        titelTableEN={"Volunteer and community work"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!props.disabled}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        hideIconsAction={true}
        checkBoks={false}
        nameColumAction=""
        showIconsApplication={true}
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            // title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
            titleEN={popUpBody.titleEN}
            title={popUpBody.title}
          />
        }
      />
    </>
  );
};
export default VoluntaryCommunityWork;
